var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_147",
    "data-name": "Raggruppa 147",
    transform: "translate(-1859 -201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_146",
    "data-name": "Raggruppa 146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_94",
    "data-name": "Rettangolo 94",
    width: 30,
    height: 30,
    transform: "translate(1859 201)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_145",
    "data-name": "Raggruppa 145",
    transform: "translate(1867.227 210.227)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_17",
    "data-name": "Linea 17",
    x2: 13,
    y2: 13,
    transform: "translate(-0.226 -0.227)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_18",
    "data-name": "Linea 18",
    y1: 13,
    x2: 13,
    transform: "translate(-0.226 -0.227)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.0adad0ffc199ebf4824484a24380142b.svg";
export { ForwardRef as ReactComponent };